import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Filter } from '../filter-state';

const PREFIX = 'FilterChips';

const classes = {
  enabled: `${PREFIX}-enabled`,
  disabled: `${PREFIX}-disabled`,
  chip: `${PREFIX}-chip`,
  chipDelete: `${PREFIX}-chipDelete`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.enabled}`]: {
    background: theme.palette.background.default,
    '&:focus': {
      background: theme.palette.background.default
    }
  },

  [`& .${classes.disabled}`]: {
    background: 'lightgrey',
    '&:focus': { background: 'lightgrey' }
  }
}));

interface FilterChipsProps {
  filters?: Filter[];
  toggleFilter?: (filter: Filter) => void;
  removeFilter?: (filter: Filter) => void;
}

const FilterChips = ({
  filters = [],
  toggleFilter = () => null,
  removeFilter = () => null
}: FilterChipsProps) => {
  return (
    <Root data-testid="filter-chip-container">
      {filters.map((filter: Filter) => {
        return (
          <Chip
            data-testid="filter-chip"
            data-enabled={filter.enabled}
            key={filter._id}
            label={filter.name}
            className={filter.enabled ? classes.enabled : classes.disabled}
            onDelete={() => removeFilter(filter)}
            onClick={() => toggleFilter(filter)}
            sx={{
              marginRight: 1,
              marginBottom: 1,
              borderRadius: '4px',
              '&:hover ': {
                '& .MuiChip-deleteIcon': {
                  visibility: 'visible'
                }
              },
              '& .MuiChip-deleteIcon': {
                visibility: 'hidden'
              }
            }}
          />
        );
      })}
    </Root>
  );
};

export default FilterChips;
